const imgData_2023 = {
  shadow_dragon: {
    title: 'Shadow Dragon',
    imgs: {
      full: {
        src: require('./shadow_dragon_2023_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./shadow_dragon_2023_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2023',
    description: 'Pen and watercolour on paper. 210 x 297 mm, 2023.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'A commissioned painting of a dragon character, with a body of a panther and the scales black as the night. The mane is flaming and this dragon can stretch its fingers when it controls the shadows of the shadow world.',
  },
  apologies: {
    title: 'Apologies',
    imgs: {
      full: {
        src: require('./apologies_2023_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./apologies_2023_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2023',
    description:
      'Pen, markers, coloured pencils and watercolour on paper. 191 x 281 mm, 2023.',
    price: 126,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: 'https://www.etsy.com/ie/listing/1617658522/',
    ship: 'FREE_IRL',
    merch: [
      {
        name: 'Colouring Page - Digital',
        url: 'https://www.etsy.com/ie/listing/1598207916/',
        /* prettier-ignore */
        price: 5.60,
        discount: 0,
        digital: true,
      },
    ],
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "This painting symbolises apologising: the white doves and the lilies are symbols of forgiving, embracing yet evading the claws of the dragon. When you're too bold apologies can just fly like ghosts around you, and no matter how much you grab you won't hold any of the forgiveness.",
  },
  doodle_monsters: {
    title: 'Doodle Monsters',
    imgs: {
      full: {
        src: require('./doodle_monsters_2023_web.jpg'),
        width: 1061,
        height: 1500,
      },
      thumb: {
        src: require('./doodle_monsters_2023_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2023',
    description:
      'Coloured pencils and watercolour on paper. 149 x 200 mm, 2023.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'A commissioned painting made as a gift for a fellow artist :) The figures are based on the doodles she made.',
  },
  batwatching: {
    title: 'Batwatching',
    imgs: {
      full: {
        src: require('./batwatching_2023_web.jpg'),
        width: 1500,
        height: 1061,
      },
      thumb: {
        src: require('./batwatching_2023_thumb.jpg'),
        width: 600,
        height: 424,
      },
    },
    year: '2023',
    description: 'Pen and watercolour on paper. 420 x 297 mm, 2023.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'A commissioned piece of a couple doing their favourite activity: watching the bats fly when the sun starts to set. I really enjoyed painting these characters based on the commissioner and her wife and bringing a wonderful moment in the day to life.',
  },
  raven_wreath: {
    title: 'Raven Wreath',
    imgs: {
      full: {
        src: require('./raven_wreath_2023_web.jpg'),
        width: 1066,
        height: 1500,
      },
      thumb: {
        src: require('./raven_wreath_2023_thumb.jpg'),
        width: 426,
        height: 600,
      },
    },
    year: '2023',
    description:
      'Coloured pencils and watercolour on paper. 149 x 200 mm, 2023.',
    price: 76,
    original: 'MSG',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "Another piece made with a set materials from a subscription art box. This time I had coloured pencils and watercolours with beautiful shades of blue and red. A circular shape can represent an enclosed area, a zone, but it can also stand for infinity. That's my wreath, a symbol of continuity and spirits breaking out from its enclosed space.",
  },
  green_and_red_2: {
    title: 'Green and Red II',
    imgs: {
      full: {
        src: require('./green_and_red_2_2023_web.jpg'),
        width: 1109,
        height: 1500,
      },
      thumb: {
        src: require('./green_and_red_2_2023_thumb.jpg'),
        width: 444,
        height: 600,
      },
    },
    year: '2023',
    description:
      'Coloured pencils and watercolour on paper. App 148 x 210 mm, 2023.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'A companion piece to Red and Green I. Same idea, different composition.',
  },
  green_and_red_1: {
    title: 'Green and Red I',
    imgs: {
      full: {
        src: require('./green_and_red_1_2023_web.jpg'),
        width: 1121,
        height: 1500,
      },
      thumb: {
        src: require('./green_and_red_1_2023_thumb.jpg'),
        width: 448,
        height: 600,
      },
    },
    year: '2023',
    description:
      'Pen, markers and coloured pencil on paper. 283 x 380 mm, 2023.',
    price: 0,
    original: 'SOLD',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "I was thinking about naming this painting 'Opponent Process Theory' as green and red are two of the most contrasting colours. There's no greenish red or reddish green, it's either or. In psychology an example to this theory is when you're afraid of something, but you still keep doing it, your brain must resolve the situation somehow, so eventually you either give up doing the thing, or you won't be afraid of it anymore. The two can't exist alongside, so you change.<br /><br />So how does green and red work together? They have different qualities and when you put these two together something new must come to life.",
  },
  persevarence: {
    title: 'Persevarence',
    imgs: {
      full: {
        src: require('./persevarence_2023_web.jpg'),
        width: 1118,
        height: 1500,
      },
      thumb: {
        src: require('./persevarence_2023_thumb.jpg'),
        width: 447,
        height: 600,
      },
    },
    year: '2023',
    description:
      'Pen, markers and coloured pencil on paper. 210 x 297 mm, 2023.',
    price: 136,
    original: 'MSG',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: '',
    ship: 'FREE_IRL',
    merch: [
      {
        name: 'Colouring Page - Digital',
        url: 'https://www.etsy.com/ie/listing/1457555934/',
        /* prettier-ignore */
        price: 5.50,
        discount: 0,
      },
    ],
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "I had this image in my head for a while with the dragon's pose, the roses kinda came along on the way. The birds were part of the original idea.",
  },
  the_gardener: {
    title: 'The Gardener',
    imgs: {
      full: {
        src: require('./the_gardener_2023_web.jpg'),
        width: 1500,
        height: 1061,
      },
      thumb: {
        src: require('./the_gardener_2023_thumb.jpg'),
        width: 600,
        height: 424,
      },
    },
    year: '2023',
    description:
      'Pen, markers and coloured pencil on paper. 420 x 297 mm, 2023.',
    price: 146,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: 'https://www.etsy.com/ie/listing/1462645451/',
    ship: 'FREE_IRL',
    merch: [
      {
        name: 'Colouring Page - Printed',
        url: 'https://www.etsy.com/ie/listing/1428894428/',
        /* prettier-ignore */
        price: 6,
        discount: 0,
      },
    ],
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      'I know foxgloves are sweet flowers to most people so it might be shocking to see them weeded out. Foxgloves are also the flowers of insecurity, plus they are associated with the fairy folk, so I hope none gets offended.',
  },
  sword: {
    title: 'Sword',
    imgs: {
      full: {
        src: require('./sword_2023_web.jpg'),
        width: 1118,
        height: 1500,
      },
      thumb: {
        src: require('./sword_2023_thumb.jpg'),
        width: 447,
        height: 600,
      },
    },
    year: '2023',
    description: 'Ink and coloured pencil on paper. 148 x 210 mm, 2023.',
    price: 96,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: 'https://www.etsy.com/ie/listing/1443608524/',
    ship: 'FREE_IRL',
    merch: [
      {
        name: 'Colouring Page - Printed',
        url: 'https://www.etsy.com/ie/listing/1457823237/',
        /* prettier-ignore */
        price: 4,
        discount: 0,
      },
      {
        name: 'Colouring Page - Digital',
        url: 'https://www.etsy.com/ie/listing/1461566010/',
        /* prettier-ignore */
        price: 5.50,
        discount: 0,
        digital: true,
      },
    ],
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "For this little dragon painting I used only ink: 2 types of sepia, yellow and my favourite, the golden one. That gold adds a beautiful shine to the finished work, can't wait to show the photos of it!",
  },
  senescence: {
    title: 'Senescence',
    imgs: {
      full: {
        src: require('./senescence_2023_web.jpg'),
        width: 1118,
        height: 1500,
      },
      thumb: {
        src: require('./senescence_2023_thumb.jpg'),
        width: 447,
        height: 600,
      },
    },
    year: '2023',
    description:
      'Pen, markers and coloured pencils on paper. 283 x 380 mm, 2023.',
    price: 136,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: 'https://www.etsy.com/ie/listing/1411542073/',
    ship: 'FREE_IRL',
    merch: [
      {
        name: 'Colouring Page - Printed',
        url: 'https://www.etsy.com/ie/listing/1393626597/',
        /* prettier-ignore */
        price: 6.50,
        discount: 0,
      },
    ],
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'fantasy_watercolour_painting',
    story:
      "The title means \"deterioration with age\" and is usually used in biology to describe when flowers change colour over the lifecycle of their blooming. Is this deterioration really? I'd call it maturing. We don't think ourselves as being deteriorating as we grow up, it's just a change, something that was becomes something new. Maybe something better. The red primroses turn into yellow ones.<br /><br />And the griffin, a heraldic animal of valour and leadership, but also of longevity and loyalty, gets caught in the change. It's definitely not deterioration, it's just a change.",
  },
};

export default imgData_2023;
